import { useGetClientGroup } from '@/views/Documents/hooks/useGetClientGroup';
import { useGetOffer } from '@/views/Documents/hooks/useGetOffer';
import type { ErrorMessage } from '@/views/NewInteraction/types';

interface UseDefaultBuyerParams {
  sourceId?: string;
  buyerId?: string;
}

export function useDefaultBuyer({ sourceId, buyerId }: UseDefaultBuyerParams) {
  // Fetch offer data when sourceId is provided
  const {
    offer,
    error: offerError,
    isLoading: offerLoading,
  } = useGetOffer(sourceId ?? null);

  // Use clientGroupId from source offer if sourceId is present, otherwise use buyerId
  const clientGroupId = sourceId ? offer?.clientGroupId : buyerId;

  // Fetch client group data
  const {
    clientGroup,
    error: clientGroupError,
    isLoading: clientGroupLoading,
  } = useGetClientGroup(clientGroupId ?? null);

  // Determine error state
  let error: ErrorMessage | undefined;
  if (offerError) {
    error = 'errorCloneTransaction';
  } else if (clientGroupError) {
    error = 'errorLoadingPage';
  }

  return {
    defaultBuyer: clientGroup,
    defaultBuyerLoading: offerLoading || clientGroupLoading,
    error,
  };
}
